import { Button, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CheckIcon from '@material-ui/icons/Check';

const useStyles = makeStyles(theme => ({
  modalContent: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    position: 'absolute',
    width: 450,
    maxHeight: '480px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 0 20px rgba(0,0,0,0.2)',
    overflow: 'hidden',
  },
  modalBody: {
    padding: '24px',
    overflowY: 'hidden',
    flex: 1,
  },
  actions: {
    borderTop: '1px solid #eee',
    padding: '16px 24px',
    textAlign: 'right',
    backgroundColor: '#fff',
    position: 'sticky',
    bottom: 0,
    zIndex: 1,
  },
  Header: {
    marginBottom: 16,
    backgroundColor: theme.palette.background.paper,
    fontSize: 18,
    fontFamily: 'Conv_AtlasGrotesk-Medium-App',
  },
  userUpdate: {
    fontSize: 16,
    lineHeight: '20px',
  },
  successMessage: {
    color: 'green',
  },
  okButton: {
    fontSize: 14,
    lineHeight: '42px',
    height: 42,
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#000',
    fontFamily: 'Conv_AtlasGrotesk-Medium-App',
    textTransform: 'inherit',
    marginLeft: 20,
    padding: '0 45px',
    border: 'none',
    borderRadius: '0px',
    '&:hover': {
      backgroundColor: '#222',
    },
  },
  copyButtonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 20,
  },
  copyButton: {
    fontSize: 14,
    height: 32,
    color: '#000',
    backgroundColor: 'transparent',
    fontFamily: 'Conv_AtlasGrotesk-Medium-App',
    textTransform: 'inherit',
    padding: '0 8px',
    border: 'none',
    borderRadius: 4,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },

  failedUsersListWrapper: {
    maxHeight: '300px',
    overflowY: 'auto',
    marginTop: 16,
    paddingRight: 4,
    paddingBottom: 20,
  },

  failedUsersList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    padding: 0,
    listStyle: 'none',
    margin: 0,
    '& li': {
      padding: '12px 16px',
      border: '1px solid #e0e0e0',
      borderRadius: 8,
      backgroundColor: '#fafafa',
      boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    },
    '& li p': {
      margin: 0,
      fontWeight: 600,
      fontSize: 14,
    },
    '& li span:first-of-type': {
      display: 'block',
      fontSize: 13,
      color: '#444',
      marginTop: 4,
    },
    '& li span:last-of-type': {
      display: 'block',
      fontSize: 12,
      color: '#d32f2f',
      marginTop: 6,
    },
  },
}));

export default function SuccessPopup({ open, handleClose, updatedUsers }) {
  const { failedUsers = [], successUsers = [] } = updatedUsers || {};
  
  if (failedUsers.length === 0 && successUsers.length === 0) {
    return null;
  }

  const classes = useStyles();
  const [copied, setCopied] = useState(false);
  const handleCopy = () => {
    const textToCopy = `${failedUsers
      .map(
        user =>
          `ID: ${user.id}, Name: ${user.user}, Email: ${user.email}, Reason: ${user.reason}`,
      )
      .join('\n')}`.trim();

    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div className={classes.modalContent}>
        <div className={classes.modalBody}>
          <h2 className={classes.Header}>Smart Key</h2>
          {failedUsers.length > 0 ? (
            <>
              <div className={classes.copyButtonWrapper}>
                <p className={classes.userUpdate}>
                  Update failed for following users:
                </p>
                <Button
                  onClick={handleCopy}
                  className={classes.copyButton}
                  startIcon={
                    copied ? (
                      <CheckIcon fontSize="small" />
                    ) : (
                      <FileCopyIcon fontSize="small" />
                    )
                  }
                >
                  {copied ? 'Copied' : 'Copy'}
                </Button>
              </div>

              <div className={classes.failedUsersListWrapper}>
                <ul className={classes.failedUsersList}>
                  {failedUsers.map(user => (
                    <li key={user.id}>
                      <p>{user.user}</p>
                      <span>{user.email}</span>
                      <span>{user.reason}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          ) : (
            <p className={`${classes.userUpdate} ${classes.successMessage}`}>
              Changes have been applied successfully.
            </p>
          )}
        </div>
        <div className={classes.actions}>
          <Button onClick={handleClose} className={classes.okButton}>
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
}
